const $features = document.getElementById('features');

if ($features) {
	let $items = $features.querySelectorAll('.item-feature');

	listener('mouseover', '.item-feature', function (item, e) {
		e.preventDefault();

		rotateEllipse(item);
	});

	listener('mouseover', '.dot', function (item, e) {
		e.preventDefault();

		rotateEllipse(item);
	});

	listener('mouseout', '.features-wrapper', function (item, e) {
		e.preventDefault();

		let $dots = document.querySelectorAll('[data-dot]');

		for (const $dot of $dots) {
			$dot.classList.remove('active');
		}

		/*let ellipse = document.querySelector('.ellipse-active');
		if (ellipse) {
			ellipse.classList.remove('active')
		}*/
	});

	function rotateEllipse(item) {
		let key = Number(item.dataset.key);
		let dot = document.querySelector('[data-dot="'+ key +'"]');
		if (dot) {
			dot.classList.add('active');
		}

		let ellipse = document.querySelector('.ellipse-active');
		if (ellipse) {
			ellipse.classList.add('active');

			if (key === 0) {
				ellipse.style.transform = 'rotate(296deg)';
			}

			if (key === 1) {
				ellipse.style.transform = 'rotate(28deg)';
			}

			if (key === 2) {
				ellipse.style.transform = 'rotate(248deg)';
			}

			if (key === 3) {
				ellipse.style.transform = 'rotate(75deg)';
			}

			if (key === 4) {
				ellipse.style.transform = 'rotate(204deg)';
			}

			if (key === 5) {
				ellipse.style.transform = 'rotate(118deg)';
			}
		}
	}
}
